import { CmpInternalEmailKeyEnum } from "../../../../../graphql/types";

// Same rules and wording as the backend save (cap-backend
// src/utilities/cmpInternalEmailSettings.ts). Change both places together.
export const INTERNAL_EMAIL_SEND_TO_REQUIRED_MESSAGE = "Send To (Chamber Staff Email) is required to enable this email.";
export const INTERNAL_EMAIL_SEND_TO_INVALID_MESSAGE = "Enter a full email address in Send To (Chamber Staff Email), for example events@yourchamber.ca. Separate more than one address with a comma.";
export const INTERNAL_EMAIL_ONE_ADDRESS_MESSAGE = "Enter one email address in Send To (Chamber Staff Email) for this email.";
const MAX_SEND_TO = 10;
const singleAddressKeys = new Set([CmpInternalEmailKeyEnum.InvoiceCreated, CmpInternalEmailKeyEnum.InvoicePaid]);
const isValidEmail = (value: string) => /^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]+$/.test(value);

/** Splits on comma, semicolon or new line; trims; lower case; no repeats. */
export const parseInternalEmailSendTo = (value: string): string[] => {
  const out: string[] = [];
  for (const part of value.split(/[,;\n]/)) {
    const email = part.trim().toLowerCase();
    if (email && !out.includes(email)) out.push(email);
  }
  return out;
};

export const getInternalEmailSendToError = ({ enabled, key, sendTo }: {
  enabled: boolean;
  key: CmpInternalEmailKeyEnum;
  sendTo: string;
}): string | null => {
  const parsed = parseInternalEmailSendTo(sendTo);
  if (parsed.some(email => !isValidEmail(email))) return INTERNAL_EMAIL_SEND_TO_INVALID_MESSAGE;
  if (singleAddressKeys.has(key) && parsed.length > 1) return INTERNAL_EMAIL_ONE_ADDRESS_MESSAGE;
  if (parsed.length > MAX_SEND_TO) return `Enter ${MAX_SEND_TO} email addresses or fewer in Send To (Chamber Staff Email).`;
  if (enabled && !parsed.length) return INTERNAL_EMAIL_SEND_TO_REQUIRED_MESSAGE;
  return null;
};
